// extracted by mini-css-extract-plugin
export default {"app":"App_app__GNzSr","app-dark":"App_app-dark__niZUC"};